import cx from 'classnames'

import { Checkbox } from '../../../../shared/NarusMaterial'
import { cancelledOrCompleted } from '../../../utils'
import styles from '../select.module.scss'

export function SelectItem ({
  item,
  handleChecked,
  rel,
  disabled,
  editMode = false,
  detail = false,
  filter = false,
  issues = [],
  numbersOfSelected = null
}) {
  const value = filter
    ? rel?.find(r => r === item.id)
    : rel?.find(r => r?.id === item.id)

  const name = filter
    ? `${item.name} ${numbersOfSelected?.[item.name] ? `(${numbersOfSelected?.[item.name]})` : ''}`
    : item.name

  const temp = issues?.find(
    iss =>
      iss.relations?.find(relation => relation.id === value?.id) &&
      !cancelledOrCompleted(iss)
  )

  const existedIssue = value && temp
  const lock = existedIssue && !detail && !editMode
  const unavailable = item?.unavailable

  const handleClick = () => {
    if (!unavailable && !disabled) {
      handleChecked()
    }
  }

  return (unavailable && temp) || !unavailable
    ? (
      <div
        className={cx(styles.selectItem, {
          [styles.disabled]: lock
        })}
        id={item.name}
        onClick={handleClick}
        aria-hidden='true'
      >
        {!editMode && (
          <Checkbox
            value={filter ? value : existedIssue}
            disabled={disabled}
          />
        )}
        <div
          className={cx(styles.text, {
            [styles.unavailable]: unavailable
          })}
        >
          {name.replaceAll('_', ' | ')}
        </div>
      </div>
    )
    : (
      ''
    )
}
